import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ap_course_status_type } from '../strategies/ap_course_status_strategy';
import { APCourse } from './ap_course_builder';

export interface IAPPlannedCourseMeta {
  id: number;
  _course: APCourse;
  _section_type_keys: key[];
  _section_types: any;
  _hasMultiSections: boolean;
  _multiSectionLabels: string;
  _hasRequisiteProblem: boolean;
  _hasCourseOfferedProblem: boolean;
  _hasCoReq: boolean;
  _hasPreReq: boolean;
  _coreq_miss: APCourse[];
  _coreq_outoforder: APCourse[];
  _prereq_miss: APCourse[];
  _prereq_outoforder: APCourse[];
  _coreq: APCourse[];
}

export class APPlannedCourse {
  coreq_miss: number[];
  coreq_outoforder: number[];
  course: number;
  id: number;
  is_coreq_satisfied: boolean;
  is_locked: boolean;
  is_prereq_satisfied: boolean;
  is_prereq_course_satisfied: boolean;
  is_prereq_grade_satisfied: boolean;
  prereq_miss: number[];
  prereq_outoforder: number[];
  program_slot: number;
  status: ap_course_status_type;
  term: number;
  is_course_offered: boolean;
  actual_grade_point: number;

  constructor(plannedCourse: Partial<APPlannedCourse>) {
    if (_4.isNull(plannedCourse.status)) {
      plannedCourse.status = '';
    }
    _4.merge(this, {}, plannedCourse);
  }

  static build(plannedCourse: Partial<APPlannedCourse>): APPlannedCourse {
    return new APPlannedCourse(plannedCourse);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_planned_course_builder.ts